import axios from 'axios';

export default function setAuthorizationToken(token) {


  if (token && token !== 'undefined') {
    axios.defaults.headers.common['Authorization'] = `lksv+++${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
}
